import React from 'react';

import { Trend, TrendValue } from '../trend-value';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { formatNumber } from '@/lib/formatNumber';

export const description = 'A card to display metrics and its trend';

export interface MetricCardProps {
  title: string;
  value: string;
  trend: Trend;
  trendValue: string;
  className?: string;
}

export function MetricCard({ title, value, trend, trendValue, className }: MetricCardProps) {
  let formattedValue = formatNumber(Number(value));
  if (isNaN(Number(value))) {
    formattedValue = value;
  }
  const showTooltip = Number(value) >= 1000;

  return (
    <Card className={cn('p-4 shadow-none', className)}>
      <CardHeader className="p-0 space-y-0" data-name="header">
        <CardDescription data-name="title" className="uppercase font-inter heading-xxxs tracking-normal text-dark">
          {title}
        </CardDescription>
        <CardTitle className="justify-start text-dark text-[64px] font-normal font-inter leading-[72px]">
          {showTooltip ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <span>{formattedValue}</span>
              </TooltipTrigger>
              <TooltipContent>{value}</TooltipContent>
            </Tooltip>
          ) : (
            <span>{formattedValue}</span>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent
        data-name="content"
        className={cn('p-0 flex items-center gap-[2px]', {
          'text-green-600': trend === Trend.UP,
          'text-red-600': trend === Trend.DOWN,
          'text-dark-600': trend === Trend.FLAT,
        })}
      >
        <TrendValue trend={trend} trendValue={trendValue} />
      </CardContent>
    </Card>
  );
}
